import React, { useEffect, useState } from "react";
import Input from "sushiweb/InputTypes/Input";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import styles from "../../../../constants/assets/variables";
import { isValidated, getInitialState, filterObj } from "../../../../utils";
import * as DriverAccountingActions from "../../../../store/actions/DriverAccounting";
import { BottomSectionModal } from "../../../../constants/assets/containers";
import Button from "sushiweb/Button";
import NoFooterModal from "../../../Common/NoFooterModal";

const mandatoryFields = ["process_type", "start_date"];

const SettlementProcessesFormModal = (props) => {
  const [formError, setFormError] = useState("");
  const [initialState, setInitialState] = useState({
    process_type: "online",
    start_date: " ",
    end_date: " ",
  });
  const {
    modalState,
    handleClose,
    activeFilters,
    filterFields,
    currentPage,
    heading,
  } = props;

  // it validates the start_date for the settlement process.
  const validateStartDate = (date) => {
    const startDate = new Date(date);
    const startDay = startDate.getDay();
    const currentDate = new Date();
    const currentDay = currentDate.getDay();
    const diff =
      currentDate.getDate() - currentDay + (currentDay === 0 ? -6 : 1);
    const currentWeekMonday = new Date(currentDate.setDate(diff));
    if (startDay !== 1 || startDate.getTime() >= currentWeekMonday.getTime()) {
      return "Select only 'Monday' and less than today's date as start date";
    }
    return "validated";
  };

  const handleFilterClick = (evt) => {
    evt.preventDefault();
    const filters = {};
    for (let key of filterFields) {
      if (initialState[key] && initialState[key].trim().length > 0) {
        filters[key] = initialState[key];
      }
    }

    // don't send a request if no filter is applied
    if (Object.keys(filters).length === 0) {
      handleClose();
      return;
    }

    props.getSettlementProcesses(filters, {}).then((res) => {
      handleClose();
    });
  };

  const handleModalClose = () => {
    if (modalState === "Filter") {
      Object.keys(activeFilters).length > 0 &&
        props.getSettlementProcesses({}).then((res) => {
          props.resetState({ state: "activeSettlementProcessesFilters" });
        });
    }
    handleClose();
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    const body = filterObj(initialState, [
      "process_type",
      "start_date",
      "end_date",
    ]);
    let validatedState = isValidated(body, mandatoryFields);
    if (validatedState === "validated") {
      validatedState = validateStartDate(body["start_date"]);
    }
    if (validatedState === "validated") {
      props.createSettlementProcess(body).then((res) => {
        const pageRequest = { page_number: currentPage };
        props.getSettlementProcesses(activeFilters, pageRequest);
        handleClose();
      });
    } else {
      setFormError(validatedState);
    }
  };

  // adds 6 days to the start date and returns end date in string format with date-format: yyyy-mm-dd
  const getEndDate = (startDate) => {
    const endDateObj = new Date(new Date(startDate).getTime() + 6 * 86400000);
    const endDateStr = `${endDateObj.getFullYear()}-${`0${
      endDateObj.getMonth() + 1
    }`.slice(-2)}-${`0${endDateObj.getDate()}`.slice(-2)}`;
    return endDateStr;
  };

  const handleChange = (key, val) => {
    const values = { ...initialState };
    values[key] = val;

    // set end date automatically.
    if (modalState === "Add" && key === "start_date") {
      if (!isNaN(new Date(val).getDate())) {
        values["end_date"] = getEndDate(val);
      }
    }

    setInitialState(values);
  };

  useEffect(() => {
    // update the initialState on modal render.
    // this is not needed when modalState is "Add".
    if (Object.keys(activeFilters).length > 0 && modalState === "Filter") {
      const values = { ...initialState };
      Object.keys(values).map((key) => {
        values[key] = activeFilters[key]
          ? activeFilters[key]
          : getInitialState(initialState, key);
      });
      setInitialState(values);
    }
  }, [activeFilters]);

  // Returns true/false based on should the fields be disabled
  // on different states of modal.
  const isDisabledField = (value) => {
    if (modalState === "Filter") {
      if (filterFields.includes(value)) {
        return false;
      }
      return true;
    } else if (modalState === "Add") {
      if (mandatoryFields.includes(value)) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  };

  return (
    <NoFooterModal
      header
      heading={heading}
      handleClose={handleModalClose}
      id="settlementProcessFormModal"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          {modalState === "Filter" && (
            <Button
              data-testid="settlementProcessFormClearBtn"
              onClick={handleModalClose}
              className="sushi-btn"
            >
              Clear
            </Button>
          )}
          <Button
            data-testid="settlementProcessFormSubmitBtn"
            onClick={modalState === "Filter" ? handleFilterClick : handleSubmit}
            className="sushi-btn"
          >
            {modalState === "Filter" ? "Apply" : "Submit"}
          </Button>
        </BottomSectionModal>
      }
    >
      <div id="roles-form">
        {modalState === "Add" ? (
          <Input
            disabled={true}
            borderColor={styles.primaryColor}
            id="sushi-input"
            fullWidth={true}
            value={initialState.process_type}
            label="Process Type"
          />
        ) : (
          ""
        )}
        <Input
          disabled={isDisabledField("start_date")}
          borderColor={styles.primaryColor}
          id="sushi-input"
          fullWidth={true}
          value={initialState.start_date}
          autoFocus={true}
          label="Start Date"
          type="date"
          onChange={(val) => handleChange("start_date", val)}
          data-testid="start_date_input"
        />
        <Input
          disabled={isDisabledField("end_date")}
          borderColor={styles.primaryColor}
          id="sushi-input"
          fullWidth={true}
          value={initialState.end_date}
          label="End Date"
          type="date"
          onChange={(val) => handleChange("end_date", val)}
        />
      </div>
      {formError.length > 0 ? (
        <div className={"error-state"}>{"*" + formError}</div>
      ) : (
        ""
      )}
    </NoFooterModal>
  );
};

const mapStateToProps = (state) => {
  const { DriverAccounting } = state;
  return {
    currentPage: DriverAccounting.currentPage,
    activeFilters: DriverAccounting.activeSettlementProcessesFilters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createSettlementProcess: bindActionCreators(
      DriverAccountingActions.createSettlementProcess,
      dispatch
    ),
    getSettlementProcesses: bindActionCreators(
      DriverAccountingActions.getSettlementProcesses,
      dispatch
    ),
    resetState: bindActionCreators(
      DriverAccountingActions.resetState,
      dispatch
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SettlementProcessesFormModal);
